import React, { useEffect, useState } from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import DataComponent from 'EurestoComponents/DataComponents'
import Grid from '@material-ui/core/Grid'
import Data from 'EurestoClass/Data'
import Utils from 'EurestoFonction/Utils'

export default React.memo(props => {

  const [object, setObject] = useState(props.object || {})
  const [key, setKey] = useState(Utils.getRandomNumber())
  const [disabled, setDisabled] = useState(props.disabled || false)

  const onChange = (data, name) => {
    const obj = {
      ...(object || {}),
      [name]: data
    }
    setObject(obj)
    props.onChange && props.onChange(EurestoClone(obj))
  }

  useEffect(() => {
    if (!_.isEqual(props.object, object)) {
      setKey(Utils.getRandomNumber())
      setObject(props.object || {})
    }
  }, [props.object])

  return (
    <Grid key={key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column" justify="flex-start"
      alignItems="stretch">
      <Traduction
        autoFocus={!disabled}
        title={EurestoI18n.t('commun:Nom')}
        onChange={onChange}
        name={'libelle'}
        disabled={disabled}
        data={object.libelle !== undefined ? object.libelle : []}
        type={Constants.typeSaisie.SaisieLibre}
      />
      <Select
        title={EurestoI18n.t('commun:Entité')}
        name="type_entite_information"
        multiple={true}
        disabled={disabled}
        options={Constants.usefullObjectStatic[Constants.module.CRM + '-' + Constants.donnee.info_tiers].entite.filter(o => o.condition ? o.condition() : true).map(o => ({
          label: o.libelle,
          value: o.id
        }))}
        value={object.type_entite_information && (typeof object.type_entite_information === 'string' && JSON.parse(object.type_entite_information) || object.type_entite_information) || []}
        onChange={onChange} />
      <DataComponent
        title={EurestoI18n.t('commun:Qualite')}
        name="qualites"
        disabled={disabled}
        type={Constants.typeSaisie.ComboMulti}
        onChange={onChange}
        data={object.qualites || []}
        object={Constants.donnee.qualite}
        module={Constants.module.CRM}
        search={object.type_entite_information !== undefined ? { type: { contains: object.type_entite_information } } : {}}
      />
      <Select
        autoComplete={false}
        title={EurestoI18n.t('commun:Ordre')}
        name="ordre"
        disabled={disabled}
        options={[...Array((Data.list(Constants.module.CRM, Constants.donnee.onglet, {}).length + (object.action === 'update' ? 0 : 1))).keys()].map(o => ({
          label: o + 1,
          value: o + 1
        }))}
        value={object.ordre !== undefined ? object.ordre : 0}
        onChange={onChange} />
    </Grid>
  )
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/CRM/Onglet/form.js